import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { Alignment } from "../content-builder/element-schema";
/**
 * Schema for star rating widget with validation
 */
export const starRatingWidgetParser = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  alignment: createEnum(Alignment),
  starPadding: z.number(),
  starSize: z.number(),
  emptyStarColor: z.string(),
  filledStarColor: z.string(),
  showStarsWhenNoReviews: z.boolean(),
  starOutlineEnabled: z.boolean(),
  starOutlineColor: z.string(),
  starOutlineWidth: z.number(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const defaultStarRatingWidget = {
  alignment: Alignment.LEFT,
  starPadding: 0,
  starSize: 18,
  emptyStarColor: "#E5E5E5",
  filledStarColor: "#FEC84B",
  showStarsWhenNoReviews: true,
  starOutlineEnabled: false,
  starOutlineColor: "#000",
  starOutlineWidth: 1,
};

export type StarRatingWidget = z.infer<typeof starRatingWidgetParser>;
